var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingmodal",staticStyle:{"background-color":"rgba(255, 255, 255, 0.7)","backdrop-filter":"blur(4px)"}},[_c('img',{attrs:{"src":require("@/assets/icons/ic_spinner.svg")}}),_c('div',{staticClass:"loadingmodal__label"},[_vm._v(" Loading... ")]),_c('div',{staticClass:"loadingmodal__sublabel"})])
}]

export { render, staticRenderFns }